<script>
    //后台服务器地址
    //const serverURL='http://123.233.246.138:8588';
    const serverURL='http://123.233.246.138:8588'

    export default
    {
        serverURL

    }
</script>